import { createSelector } from 'reselect'
import find from 'lodash/find'

export const selectSlug = (_, { params }) => params.slug
export const selectPages = (store) => store.pages.data

export const selectPage = createSelector(
  [ selectPages, selectSlug ],
  (pages = [], slug) => find(pages, (page) => page.slug === slug)
)

export const selectPageMeta = createSelector(
  [ selectPage ],
  (page = {}) => page.meta || {}
)
